var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_225",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3e6191",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2947",
    "data-name": "Group 2947",
    transform: "translate(-164 -694)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 164, 694)",
    filter: "url(#Ellipse_225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_225-2",
    "data-name": "Ellipse 225",
    transform: "translate(9 6)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Picto_photo",
    "data-name": "Picto/photo",
    transform: "translate(179.498 707.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M2.169,19.477H14.331a2.251,2.251,0,0,0,2.17-2.319V10.289A2.251,2.251,0,0,0,14.336,7.97h.017V7.61a.309.309,0,0,0-.292-.359H12.892a.347.347,0,0,0-.334.36v.36h-.432A2.218,2.218,0,0,0,9.992,6.052H6.508A2.219,2.219,0,0,0,4.374,7.97h-2.2A2.251,2.251,0,0,0,0,10.289v6.869A2.251,2.251,0,0,0,2.169,19.477ZM.717,10.289A1.5,1.5,0,0,1,2.169,8.743H5.056l.056-.773a1.47,1.47,0,0,1,1.4-1.145H9.992a1.469,1.469,0,0,1,1.4,1.145l.056.773h2.886a1.5,1.5,0,0,1,1.453,1.546v6.869A1.5,1.5,0,0,1,14.331,18.7H2.169A1.5,1.5,0,0,1,.717,17.158V10.289Zm5.37-1.72h4.276a.293.293,0,0,0,0-.584H6.087a.293.293,0,0,0,0,.584Zm2.163,9.467A4.219,4.219,0,0,0,12.3,13.673,4.22,4.22,0,0,0,8.251,9.311,4.219,4.219,0,0,0,4.2,13.673,4.219,4.219,0,0,0,8.251,18.036Zm0-7.995a3.513,3.513,0,0,1,3.371,3.633,3.513,3.513,0,0,1-3.371,3.633,3.513,3.513,0,0,1-3.372-3.633A3.513,3.513,0,0,1,8.251,10.041Z",
    transform: "translate(0 -6.052)",
    fill: "#006cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M122.978,940.43c-.159,1.153-1.9,2.061-4.025,2.061-.107,0-.212,0-.317-.008a2.6,2.6,0,0,0,1.969.865,2.374,2.374,0,0,0,2.494-2.233A2.017,2.017,0,0,0,122.978,940.43Z",
    transform: "translate(-112.37 -932.669)",
    fill: "#d7e4f2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9e066a9998baa7487d0a982fd1f19828.svg";
export { ForwardRef as ReactComponent };